import React from "react";
import { toast } from "react-toastify";

const DeleteStudentModal = ({ deleteStudent, refetch, setDeleteStudent }) => {
  const handleDelete = (id) => {
    fetch(`https://evaluation-server.onrender.com/deleteStudent/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data?.deletedCount) {
          toast.warning("Student details delete successful");
          setDeleteStudent("");
          refetch();
        }
      });
  };
  return (
    <div>
      <input type="checkbox" id="my-modal-6" className="modal-toggle" />
      <div className="modal modal-bottom sm:modal-middle">
        <div className="modal-box">
          <h3 className="font-bold text-lg">Are you sure?</h3>
          <div className="modal-action">
            <label
              onClick={() => handleDelete(deleteStudent)}
              htmlFor="my-modal-6"
              className="btn"
            >
              Delete
            </label>
            <label htmlFor="my-modal-6" className="btn">
              Cancel
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteStudentModal;
